import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonService } from '../../services/common/common.service';
import { ApiUrlHelper } from '../../common/api-url-helper';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../../component/confirmation-modal/confirmation-modal.component';
import { LoginDevicesErrorMessages } from '../../constants/error-messages';

@Component({
  selector: 'app-login-devices-list',
  templateUrl: './login-devices-list.component.html',
  styleUrl: './login-devices-list.component.scss'
})
export class LoginDevicesListComponent implements OnInit {


  loginDeviceList: any;
  errorMessages = LoginDevicesErrorMessages;

  constructor(
    public modalServices: NgbActiveModal,
    private readonly commonService: CommonService,
    private readonly api: ApiUrlHelper,
    private readonly toastr: ToastrService,
    private readonly dialog: MatDialog,
    private modalService: NgbModal,
  ) { }
  ngOnInit(): void {
    this.getLoginDevices();
  }


  getLoginDevices() {

    let apiUrl = this.api.apiUrl.User.LoginDevicesList;
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: (response) => {

        const result = this.groupByOS(response.data);
        this.loginDeviceList = result;
      },
      error: (err) => {

      },
    });
  }

  groupByOS(loginData: any[]) {
    // Step 1: Grouping by OS
    const groupedByOS = loginData.reduce((acc, curr) => {
      const os = curr.os;

      if (!acc[os]) {
        acc[os] = { os, sessions: [], sessionCount: 0 };
      }
      acc[os].sessions.push(curr);
      acc[os].sessionCount++;

      return acc;
    }, {});

    // Step 2: Convert to an array
    return Object.values(groupedByOS);
  }


  logoutDevice(loginTokenId: any) {

    let apiUrl = this.api.apiUrl.User.LogoutDevice.replace("{Id}", loginTokenId?.toString());
    const modalRef = this.modalService.open(
      ConfirmationModalComponent,
      {
        backdrop: 'static',
        centered: true,
      }
    );
    (modalRef.componentInstance.title = 'Confirm');
    (modalRef.componentInstance.message = this.errorMessages.DeleteLoginDevice);
    modalRef.result.then((res: string) => {
      if (res === 'confirm') {
        this.commonService.doGet(apiUrl).pipe().subscribe({
          next: (response) => {
            if (response.success == true) {
              this.toastr.success(response.message);
              this.getLoginDevices();
            } else {
              this.toastr.error(response.message);
            }
          },
          error: (err) => {
          },
        });
      }
    });
  }

  convertUTCToLocal(date: any): Date {
    let utcTime = moment.utc(date);
    const localTime = utcTime.local();
    return localTime.toDate();
  }

  onClose(type: string) {
    this.modalServices.close(type);
  }
}
